import React from "react";
import { createRoot } from "react-dom/client";
import { ConfirmModal } from "../Components/ConfirmModal/ConfirmModal";

interface ConfirmWithContentOptions<T> {
  title?: string
  Content: React.ComponentType<{ onChange: (data: T) => void }>
  isMissionCASTExport: boolean
}

export function confirmWithContent<T>({
  title,
  Content,
  isMissionCASTExport,
}: ConfirmWithContentOptions<T>): Promise<T | null> {
  return new Promise((resolve) => {
    const container = document.createElement('div')
    document.body.appendChild(container)
    const root = createRoot(container)

    const cleanup = () => {
      root.unmount()
      container.remove()
    }

    const handleConfirm = (data: T | null) => {
      cleanup()
      resolve(data)
    }

    const handleCancel = () => {
      cleanup()
      resolve(null)
    }

    root.render(
      <ConfirmModal<T>
        title={title}
        Content={Content}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        isMissionCASTExport={isMissionCASTExport}
      />
    )
  })
}
